import BaseProgress from './Progress';

// EXPORT
export const Progress = BaseProgress;
export type { ProgressProps } from './Progress.interface';
